import axios from 'axios';
import buildUrl from 'build-url-ts';
import { START_SIMULATION, STARTING_SIMULATION_SUCCEEDED, STARTING_SIMULATION_FAILED, CREATE_PROTO_SIMULATION, CREATING_PROTO_SIMULATION_SUCCEEDED, CREATING_PROTO_SIMULATION_FAILED, INVALIDATE_SIMULATION_CREATION, STOP_SIMULATION } from '../actionTypes';
import { createAction } from "@reduxjs/toolkit";
import { takeEvery, call, put } from "redux-saga/effects";
import { CreateSimulationErrorResponse, CreateSimulationRequest, CreateSimulationResponse, StartSimulationErrorResponse, StartSimulationRequest, StartSimulationResponse } from 'src/types/simulation/simulations';

// eslint-disable-next-line no-undef
const apiUrl = process.env.REACT_APP_SIMULATION_API_URL;

export const startSimulation = createAction<CreateSimulationRequest>(CREATE_PROTO_SIMULATION);
const startingSimulationSucceeded = createAction<CreateSimulationResponse>(CREATING_PROTO_SIMULATION_SUCCEEDED);
const startingSimulationFailed = createAction<CreateSimulationErrorResponse>(CREATING_PROTO_SIMULATION_FAILED);

const startSimulationSaga = function* (action: ReturnType<typeof startSimulation>): any {
  const { scenario } = action.payload as CreateSimulationRequest;

  const url = buildUrl(apiUrl, {
    path: `/simulations/1.0/simulations`
  });

  const data = {
    scenario: scenario,
  }

  const startSessionApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(startSessionApi);
    yield put(startingSimulationSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(startingSimulationFailed({
      scenario: scenario,
      error: error,
    }));
  }
}

export const invalidateSimulationCreation = createAction<void>(INVALIDATE_SIMULATION_CREATION);

export const stopSimulation = createAction<string>(STOP_SIMULATION);

export default function* simulationSaga() {
  yield takeEvery(CREATE_PROTO_SIMULATION, startSimulationSaga);
}